import { defineStore } from 'pinia';
import MutationCall from '~/graphql/wrappers/mutation-call';
import  {
  AcceptCourseCollaborationInviteDocument,
  type AcceptCourseCollaborationInviteMutation,
  type AcceptCourseCollaborationInviteMutationVariables,
  CreateCourseCollaborationInviteDocument,
  type CreateCourseCollaborationInviteMutation,
  type CreateCourseCollaborationInviteMutationVariables,
  InvalidateCourseCollaborationInviteDocument,
  type InvalidateCourseCollaborationInviteMutation,
  type InvalidateCourseCollaborationInviteMutationVariables,
  RemoveCourseCollaboratorDocument,
  type RemoveCourseCollaboratorMutation,
  type RemoveCourseCollaboratorMutationVariables,
} from '~/graphql';

let createCourseCollaborationMutation: MutationCall<
  CreateCourseCollaborationInviteMutation,
  CreateCourseCollaborationInviteMutationVariables
>;
let invalidateCourseCollaborationMutation: MutationCall<
  InvalidateCourseCollaborationInviteMutation,
  InvalidateCourseCollaborationInviteMutationVariables
>;
let acceptCourseCollaborationMutation: MutationCall<
  AcceptCourseCollaborationInviteMutation,
  AcceptCourseCollaborationInviteMutationVariables
>;
let removeCourseCollaboratorMutation: MutationCall<
  RemoveCourseCollaboratorMutation,
  RemoveCourseCollaboratorMutationVariables
>;

export const useCourseCollaborationManagement = defineStore('courseCollaborationManagement', {
  state: () => {
    return {
      codeToAcceptAfterLogin: <string | null>null,
    };
  },
  getters: {},
  actions: {
    setCodeToAcceptAfterLogin(code: string) {
      this.codeToAcceptAfterLogin = code;
    },
    async acceptInviteAfterLogin() {
      if (this.codeToAcceptAfterLogin !== null) {
        await this.acceptCourseCollaborationInvite(this.codeToAcceptAfterLogin);
        this.codeToAcceptAfterLogin = null;
      }
    },
    async init() {
      createCourseCollaborationMutation = new MutationCall(CreateCourseCollaborationInviteDocument);
      invalidateCourseCollaborationMutation = new MutationCall(
        InvalidateCourseCollaborationInviteDocument
      );
      acceptCourseCollaborationMutation = new MutationCall(AcceptCourseCollaborationInviteDocument);
      removeCourseCollaboratorMutation = new MutationCall(RemoveCourseCollaboratorDocument);
    },
    async createCourseCollaborationInvite(id: string) {
      const result = await createCourseCollaborationMutation.run({
        courseIdInput: {
          id,
        },
      });
      if (result.hasError()) {
        console.log(result.getError());
        throw result.getError();
      }
      return result.getData().createCourseCollaborationInvite.courseInvite;
    },
    async invalidateCourseCollaborationInvite(id: string) {
      const result = await invalidateCourseCollaborationMutation.run({
        courseIdInput: {
          id,
        },
      });

      if (result.hasError()) {
        console.log(result.getError());
        throw result.getError();
      }

      return;
    },
    async removeCourseCollaborator(courseId: string, collaboratorId: string) {
      const result = await removeCourseCollaboratorMutation.run({
        removeCourseCollaboratorInput: {
          collaboratorId,
          courseId,
        },
      });

      if (result.hasError()) {
        console.log(result.getError());
        throw result.getError();
      }

      return;
    },
    async acceptCourseCollaborationInvite(code: string) {
      const result = await acceptCourseCollaborationMutation.run({
        codeInput: {
          code,
        },
      });

      if (result.hasError()) {
        console.log(result.getError());
        throw result.getError();
      }

      return result.getData().acceptCourseCollaborationInvite.course;
    },
  },
});
